import { render, staticRenderFns } from "./TestOne.vue?vue&type=template&id=0abb4c8e&scoped=true"
import script from "./TestOne.vue?vue&type=script&lang=js"
export * from "./TestOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb4c8e",
  null
  
)

export default component.exports